export default __webpack_public_path__ + "static/media/secondShape.ee6fb19f.svg";